import { render, staticRenderFns } from "./ChatListElement.vue?vue&type=template&id=a78da798&scoped=true"
import script from "./ChatListElement.vue?vue&type=script&lang=js"
export * from "./ChatListElement.vue?vue&type=script&lang=js"
import style0 from "./ChatListElement.vue?vue&type=style&index=0&id=a78da798&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78da798",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ChatListElement.vue
// module id = tocn
// module chunks = 1